import React from "react";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";

/**
 * PAGINATION - Navigation entre les pages
 * @param {Object} props
 * @param {number} props.currentPage - Page actuelle
 * @param {number} props.totalPages - Nombre total de pages
 * @param {number} props.totalItems - Nombre total d'éléments
 * @param {number} props.itemsPerPage - Éléments par page
 * @param {Function} props.onPageChange - Callback changement de page
 */
const DomainPagination = ({ 
  currentPage, 
  totalPages, 
  totalItems, 
  itemsPerPage, 
  onPageChange 
}) => {
  const startItem = (currentPage - 1) * itemsPerPage + 1;
  const endItem = Math.min(currentPage * itemsPerPage, totalItems);

  return (
    <div className="d-flex justify-content-between align-items-center mt-5">
      {/* Informations */}
      <div className="text-muted">
        Affichage de <strong className="text-primary">{startItem}-{endItem}</strong> sur{" "}
        <strong className="text-primary">{totalItems}</strong> domaines
      </div>

      {/* Navigation */}
      <nav aria-label="Navigation des domaines">
        <ul className="pagination pagination-primary mb-0">
          {/* Précédent */}
          <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
            <button
              className="page-link"
              onClick={() => onPageChange(currentPage - 1)}
              disabled={currentPage === 1}
            >
              <FaAngleLeft />
            </button>
          </li>

          {/* Pages */}
          {[...Array(totalPages)].map((_, index) => {
            const pageNumber = index + 1;
            return (
              <li key={pageNumber} className={`page-item ${currentPage === pageNumber ? 'active' : ''}`}>
                <button
                  className="page-link"
                  onClick={() => onPageChange(pageNumber)}
                >
                  {pageNumber}
                </button>
              </li>
            );
          })}

          {/* Suivant */}
          <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
            <button
              className="page-link"
              onClick={() => onPageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
              <FaAngleRight />
            </button>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default DomainPagination;